<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
  import fixedInput from  'common/js/mixin/fixedInput';
  import { getToken } from 'common/js/ovoSystem';
  import { mapActions } from 'vuex';
  export default {
    mixins: [fixedInput],
    created() {
      if (getToken() && this.$route.name != 'settle') {
        this.getuserInfo()
          .then(res => {
            if (res.code == '3' && localStorage.getItem('ifExpired') != '1') {
              localStorage.setItem('ifExpired', '1')
              gotoOAuth()
            }
          });
      }
    },
    updated(){
      // 解决ios输入框弹出的页面样式问题
      document.querySelectorAll("input").forEach(item => {
        item.onblur = this.temporaryRepair;
      });
      document.querySelectorAll("select").forEach(item => {
        item.onchange = this.temporaryRepair;
       });
      document.querySelectorAll("textarea").forEach(item => {
        item.onblur = this.temporaryRepair;
       });
    },
    methods: {
      test() {},
      ...mapActions(['getuserInfo'])
    },
  };
</script>
<style lang="scss">
@import 'common/sass/common.scss';
</style>
